import clsx from "clsx";
import { SharedIcon } from "../shared/shared-icon";

export function HeartToggleButton({
  isSaved = false,
  isLoading = false,
  toggleClickHandler = () => {},
  ...props
}) {
  const iconId = isLoading
    ? "#sprite-spinner"
    : isSaved
    ? "#sprite-heart-full"
    : "#sprite-heart";

  return (
    <button
      type="button"
      className="save-color-toggle"
      onClick={(e) => {
        e.stopPropagation();
        toggleClickHandler();
      }}
      {...props}
    >
      <div className="save-color-toggle-icon-wrapper">
        <SharedIcon
          iconName={iconId}
          className={clsx("", { "animate-spin": isLoading })}
        />
      </div>
    </button>
  );
}
